import { useIsMobile } from '../../../../hooks';

import Card from '../../../common/Card';
import { StyledLogo } from './style';

const customLogoMaxHeight: { [key: string]: string } = {
  'wheel-fortune-bmi-valentines-day': '200px',
  default: '68px',
};

interface TLogoCardProps {
  logoSrc: string;
  gameAnimationType: string;
}

const LogoCard = ({ logoSrc, gameAnimationType }: TLogoCardProps) => {
  const isMobile = useIsMobile();
  const maxHeight = customLogoMaxHeight[gameAnimationType] || customLogoMaxHeight.default;

  return (
    <Card maxWidth={isMobile ? '250px' : '500px'} marginBottom="14px">
      <StyledLogo src={logoSrc} $maxHeight={maxHeight} />
    </Card>
  );
};

export default LogoCard;
